import InventoryOptions from './InventoryOptions'
import SubMenu from '../common/SubMenu'

const Inventory = () => (
    <SubMenu componentOptions={InventoryOptions} />
)

export default Inventory